export default "__VITE_ASSET__ebde6cda__"